import { axios } from '@Root/API'

export const getTitles = () => {
	return axios.get('titles')
}
